import React from 'react';
// import './styles.css'; // import the CSS file if necessary


class MyComponent extends React.Component {
    render() {
      return (
        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ce2ebbc" data-id="ce2ebbc" data-element_type="column" data-settings='{"background_background":"classic"}'>
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-element elementor-element-3a7daa7 elementor-aspect-ratio-43 tm-rounded-box elementor-widget elementor-widget-video" data-id="3a7daa7" data-element_type="widget" data-settings='{"youtube_url":"https:\/\/www.youtube.com\/watch?v=3289oqk6zug","start":10,"autoplay":"yes","play_on_mobile":"yes","mute":"yes","loop":"yes","aspect_ratio":"43","video_type":"youtube","controls":"yes"}' data-widget_type="video.default">
              <div className="elementor-widget-container">
                <div className="elementor-wrapper elementor-fit-aspect-ratio elementor-open-inline">
                  <div className="elementor-video" />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
  
  export default MyComponent;
  